import {PModuleMeasurement, PModuleWithMeasurements} from '@/views/system/modules/interfaces';
import enumsModule, {transformFromModuleTypeStr} from '../../enumsModule';
import {httpClient} from '@/api/baseApi';
import measurementsStoreModule from '@/store/modules/entities/measurementsModule';

function getMeasurements(
  elem: any,
  measurements_dictionary: any[] | null = null,
): PModuleMeasurement[] {
  return elem.measurements.map((elem: any) => ({
    measurementId: elem.module_type_measurement_id,
    measurementDescription: elem.module_type_measurement_description,
    topWarningBoundary: elem.top_warning_boundary,
    topDangerBoundary: elem.top_danger_boundary,
    topErrorBoundary: elem.top_error_boundary,
    bottomWarningBoundary: elem.bottom_warning_boundary,
    bottomDangerBoundary: elem.bottom_danger_boundary,
    bottomErrorBoundary: elem.bottom_error_boundary,
    alias: measurements_dictionary?.filter(x => x.id == elem.module_type_measurement_id)[0].alias,
  }));
}

function transformGet(
  elem: any,
  measurements_dictionary: any[] | null = null,
): PModuleWithMeasurements {
  const type = transformFromModuleTypeStr(elem.type);
  return {
    id: elem.id,
    guid: elem.guid,
    name: elem.name,
    alias: elem.alias,
    description: elem.description,
    measurements: elem.measurements
      ? getMeasurements(elem, measurements_dictionary)
      : elem.measurements,
    //TODO: пока не приходят с сервера
    processStatus: elem.process_status,
    processStatusDescription: elem.process_status_description,
    status: elem.status,

    type,
    //TODO: временное решение, пока с сервера не передается description
    typeDescription: enumsModule.moduleTypes.filter(x => x.value == type)[0].description,
    nodes: elem.nodes,
    nodeDescription: elem.node_description || '',
    span_nodes: elem.span_nodes,
  };
}

//Получение списка объектов с сервера
export async function getAllModules(): Promise<PModuleWithMeasurements[]> {
  await measurementsStoreModule.fetchAll();
  const {data} = await httpClient.get<[]>(`modules/`);
  const transformData = data.map(x => transformGet(x, measurementsStoreModule.entities));
  return transformData;
}

//Получение списка типов событий с сервера
export async function getAllModuleBrokerEventTypes(): Promise<any> {
  const {data} = await httpClient.get<[]>(`modules/events/types/`);
  const transformData = data.map(x => x);
  return transformData;
}

//Получение списка модулей с сервера по индентификаторам
export async function getModulesByGuids(guids: string[]): Promise<PModuleWithMeasurements[]> {
  const {data} = await httpClient.get<[]>(`modules/`, {
    params: {
      guids: `[${guids.map(x => `"${x}"`).join()}]`,
    },
  });
  const transformData = data.map(x => transformGet(x));
  return transformData;
}
